import { useEffect, useState } from "react";
import { ContainerScreenGeneral, MuniSpinner2 } from "../../components"
import { useEstadisticas } from "../../hooks/useInfracciones";
import { useEstadisticasStore } from "../../store/estadisticasStore";
import {  Tab, Tabs } from '@mui/material';
import InfraccionesSemaforos from "./Charts/InfraccionesSemaforos";
import TiposVehiculos from "./Charts/TiposVehiculos";
import InfoGeneral from "./Charts/InfoGeneral";
import InfraccionesAbonadasPorMes from "./Charts/InfraccionesAbonadasPorMes";

const Estadisticas = () => {
    // const { getEstadisticas } = useEstadisticas();
    const { estadisticas } = useEstadisticasStore();
    const [tabCurrent, setTabCurrent] = useState(1);

    const handleTabs = (event, newValue) => {
        setTabCurrent(newValue);
    };

    // useEffect(() => {
    //     getEstadisticas();
    // }, [])

    return (
        <ContainerScreenGeneral linkBack={"/"} titulo={'Estadísticas'} size={"lg"}>

            <Tabs
                value={tabCurrent}
                onChange={handleTabs}
                textColor="primary"
                indicatorColor="primary"
                aria-label="secondary tabs example"
                variant="fullWidth"
            >
                <Tab value={1} label="General" />
                <Tab value={2} label="Semáforos" />
                <Tab value={3} label="Tipo vehiculo" />
                <Tab value={4} label="Infracciones abonadas por mes" />
            </Tabs>

            {tabCurrent === 1 && <InfoGeneral estadisticas={estadisticas} />}
            {tabCurrent === 2 && <InfraccionesSemaforos estadisticas={estadisticas} />}
            {tabCurrent === 3 && <TiposVehiculos estadisticas={estadisticas?.tipos} />}
            {tabCurrent === 4 && <InfraccionesAbonadasPorMes estadisticas={estadisticas?.infracciones_abonadas_por_mes} />}


        </ContainerScreenGeneral >
    );
}
export default Estadisticas;